import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getMyProfile, logout, getMyRatings } from '../api';
import './Profile.css';

const Profile: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile = async () => {
    try {
      await getMyProfile();
      const ratingsResponse = await getMyRatings();

      setStats(ratingsResponse.data);
    } catch (error) {
      console.error('Failed to load profile:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      window.location.href = '/';
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  if (loading) {
    return (
      <div className="profile-container loading">
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  return (
    <div className="profile-container">
      <div className="profile-header">
        <button className="back-btn" onClick={() => navigate('/rating')}>
          ← Back
        </button>
        <h1>Profile</h1>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>

      <div className="profile-content">
        <div className="user-info-card">
          <h2>{user?.name}</h2>
          <p className="user-email">{user?.email}</p>
        </div>

        {(() => {
          const photos = user?.photos ?? [];
          return photos.length > 0 ? (
            <div className="photos-section">
              <h3>Your Photos</h3>
              <div className="photos-grid">
                {photos.map((photo) => (
                  <div key={photo.id} className="photo-item">
                    <img src={photo.url} alt={`${user?.name ?? ''}, ${photo.order} of ${photos.length}`} />
                  </div>
                ))}
              </div>
              <button
                className="update-photos-btn"
                onClick={() => navigate('/complete-profile')}
              >
                Update Photos
              </button>
            </div>
          ) : null;
        })()}

        {stats && (
          <div className="stats-section">
            <h3>Your Rating Stats</h3>
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-value">{stats.averageRating}</div>
                <div className="stat-label">Average Rating</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">{stats.totalRatings}</div>
                <div className="stat-label">Total Ratings</div>
              </div>
            </div>
          </div>
        )}

        <div className="actions-section">
          <button onClick={() => navigate('/rating')} className="primary-btn">
            Continue Rating
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
